<div class="security-search-result">
  <a [routerLink]="['/security', security.isin]" data-test="link-to-security">{{isIndex(security) ? (security.name | index) : security.name}}</a>
  @if (!security.tradeable) {
    <small class="not-tradeable-info" data-test="not-tradeable-info">Nicht mehr gehandelt</small>
  }
</div>
